export const FETCHED_TEMPLATES = 'FETCHED_TEMPLATES';
export const SAVED_TEMPLATE = 'SAVED_TEMPLATE';
export const FETCHED_TEMPLATE = 'FETCHED_TEMPLATE';
export const MOVE_TEMPLATE_SECTION = 'MOVE_TEMPLATE_SECTION';
export const NEW_TEMPLATE_SECTION = 'NEW_TEMPLATE_SECTION';
export const FETCHED_ELEMENTS = 'FETCHED_ELEMENTS';
export const DELETE_SECTION_IN_PAGE_STATE = 'DELETE_SECTION_IN_PAGE_STATE';
export const ENABLE_SECTION_IN_PAGE_STATE = 'ENABLE_SECTION_IN_PAGE_STATE';
export const DISABLE_SECTION_IN_PAGE_STATE = 'DISABLE_SECTION_IN_PAGE_STATE';
export const DELETE_TEMPLATE_SECTION = 'DELETE_TEMPLATE_SECTION';
export const FETCHED_EDITS_HISTORY = 'FETCHED_EDITS_HISTORY';
export const ENABLE_SECTION = 'ENABLE_SECTION';
export const DISABLE_SECTION = 'DISABLE_SECTION';

//Placeholder name edit
export const UPDATE_NEW_PLACEHOLDER = 'UPDATE_NEW_PLACEHOLDER';
export const OPEN_PLACEHOLDER_EDIT_POPUP = 'OPEN_PLACEHOLDER_EDIT_POPUP';
export const CLOSE_PLACEHOLDER_EDIT_POPUP = 'CLOSE_PLACEHOLDER_EDIT_POPUP';
export const DONE_EDIT_PLACEHOLDER_POPUP = 'DONE_EDIT_PLACEHOLDER_POPUP';



// WEBPACK FOOTER //
// ./src/containers/templates/types.js